import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationPayload } from 'firebase/messaging';

@Component({
  selector: 'mom-firebase-card',
  templateUrl: './firebase-card.component.html'
})
export class FirebaseCardComponent {
  @Input() message: NotificationPayload;

  @Output() dismiss = new EventEmitter<void>();
}
